module.exports = __webpack_public_path__ + "img/9788982735363.7b411cba.jpg";